/**
 * PCM Cookie Utilities
 *
 * Small first-party cookie helpers (create/read/erase, a cookies-enabled
 * check, and a query-string reader) that older migrated content and
 * templates call as global functions. Only defines a name if nothing else
 * already has, so a newer implementation elsewhere always wins.
 */
(function(window, document) {
  'use strict';

  function getCookieDomain() {
    const hostname = window.location.hostname;

    if (hostname === 'postcardmania.com' || hostname.endsWith('.postcardmania.com')) {
      return '.postcardmania.com';
    }

    return '';
  }

  function defineGlobal(name, callback) {
    if (typeof window[name] !== 'function') {
      window[name] = callback;
    }
  }

  defineGlobal('createCookie', function(name, value, days) {
    let expires = '';

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }

    const domain = getCookieDomain();
    const domainAttribute = domain ? '; domain=' + domain : '';

    document.cookie = name + '=' + encodeURIComponent(value || '') + expires + domainAttribute + '; path=/; SameSite=Lax';
  });

  defineGlobal('readCookie', function(name) {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];

      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }

      if (cookie.indexOf(nameEQ) === 0) {
        const value = cookie.substring(nameEQ.length, cookie.length);

        try {
          return decodeURIComponent(value);
        } catch (error) {
          return value;
        }
      }
    }

    return null;
  });

  defineGlobal('eraseCookie', function(name) {
    window.createCookie(name, '', -1);
  });

  defineGlobal('cookiesCheck', function() {
    window.createCookie('__cookiecheck', '1', 1);
    const cookiesEnabled = window.readCookie('__cookiecheck');

    if (cookiesEnabled) {
      window.eraseCookie('__cookiecheck');
      return cookiesEnabled;
    }

    return null;
  });

  defineGlobal('getQueryString', function(variable) {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get(variable);
    } catch (error) {
      return null;
    }
  });
})(window, document);
